/**
 * What a person calls a part of `.mojoup/policy.json`, from the build's manifest (policyManifest.ts
 * `fields` and each clause's `label`), so the console names `tools.denyCommands` the way the
 * workbench does instead of by the bare path. A path not listed reads through its longest labelled
 * parent; `settings.<key>` names the setting by its key. A manifest from before D319 has neither,
 * and the path is shown as it is.
 */

import type { PolicyManifest } from '@aioe/shared';

export type PolicyLabeller = (path: string) => string;

export function policyLabeller(manifest: PolicyManifest | undefined): PolicyLabeller {
  if (!manifest) return (path) => path;
  const clauses = new Map(manifest.policy.clauses.map((c) => [c.path, c.label ?? c.title]));
  const fields = manifest.fields ?? {};
  return (path) => {
    if (path.startsWith('settings.')) return path.slice('settings.'.length);
    const parts = path.split('.');
    for (let n = parts.length; n > 0; n--) {
      const p = parts.slice(0, n).join('.');
      const label = fields[p]?.label ?? clauses.get(p);
      if (label) return label;
    }
    return path;
  };
}
